import styled from 'styled-components';

export const Container = styled.div`

  @media (max-width: 600px){
    overflow-x: hidden;
  }
`;

export const Body = styled.div`
  height: auto;

  @media (max-width: 600px){
    padding: 0 16px;
  }
`;
